<template>
  <div>
    <div
      :class="{
        'flex-container': true,
      }"
    >
      <v-container fluid class="rm-view-container"
        ><v-row
          ><v-col
            ><div class="rm-page-title">My Tasks and Notifications</div></v-col
          ></v-row
        >
        <v-row>
          <v-col class="mb-4 mt-2" ref="tabControl">
            <v-tabs v-model="selectedViewIndex" class="rm-tab-container">
              <v-tabs-slider class="rm-tab-slider"></v-tabs-slider>
              <v-tab class="rm-tab">Current</v-tab>
              <v-tab class="rm-tab">Historical</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <template v-if="sections.length">
          <v-row v-if="sections[selectedViewIndex].message"
            ><v-col
              ><div class="rm-view-title pl-4">
                {{ sections[selectedViewIndex].message }}
              </div></v-col
            ></v-row
          >
          <v-row v-if="sections[selectedViewIndex].notifications.length">
            <v-col>
              <div class="rm-view-title pa-4">{{sections[selectedViewIndex].textN}} Notifications</div>
              <rmTable
                :columns="notificationColumns"
                :rows="sections[selectedViewIndex].notifications"
                :maxHeight="sections[selectedViewIndex].NHeight"
                @rowClick="openDocumentSummary"
                @rowAction="(action, row, event) => handleRowAction(action, row, event)"
              ></rmTable>
            </v-col
          ></v-row>
          <v-row v-if="sections[selectedViewIndex].tasks.length">
            <v-col>
              <div class="rm-view-title pa-4">{{sections[selectedViewIndex].textT}} Tasks</div>
              <rmTable
                :columns="sections[selectedViewIndex].columnsT"
                :rows="sections[selectedViewIndex].tasks"
                :maxHeight="sections[selectedViewIndex].THeight"
                @rowClick="openDocumentSummary"
                @rowAction="(action, row, event) => handleRowAction(action, row, event)"
              ></rmTable> </v-col
          ></v-row>
        </template>      
        <v-menu
          v-model="contextMenu"
          absolute
          :position-x="posX"
          :position-y="posY"
          offset-y
          :close-on-content-click="false"
          nudge-width="300"
        >
          <v-card>
            <v-list dense>
              <v-list-item @click="openTask(currentTask)">
                <v-list-item-icon>
                  <v-icon>mdi-calendar-clock</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Task</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDocument(currentTask)">
                <v-list-item-icon>
                  <v-icon>mdi-book-open</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Document</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-container>
    </div>

    <ResponseHandler :serviceResponse="response"></ResponseHandler>

    <DocSummary
      :doc_id="documentSummary.doc_id"
      :trigger="documentSummary.trigger"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>
    <v-dialog
      v-model="taskDialogue.show"
      max-width="600px"
      style="max-height: 600px"
      scrollable
    >
      <v-card v-if="taskDialogue.show">
        <v-card-title class="d-flex align-center">
          <div class="subtitle-1">
            Task - {{ taskDialogue.document_task.task_name }} (for
            {{ taskDialogue.document_task.role_name }})
          </div>
          <v-spacer />
          <v-btn
            icon
            large
            class="btn-background"
            @click="taskDialogue.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span
                >{{ taskDialogue.document_task.document_type }}:
                {{ taskDialogue.document_task.document_reference }} -
                {{ taskDialogue.document_task.document_name }}</span
              >
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="taskDialogue.due_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    @click:prepend-inner="taskDialogue.due_date_menu = true"
                    @blur="
                      taskDialogue.due_date = parseDate(
                        taskDialogue.due_date_text
                      )
                    "
                    v-bind="attrs"
                    v-on="on"
                    label="Due"
                    placeholder="Enter Date Due"
                    required
                    v-model="taskDialogue.due_date_text"
                    class="roundish"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="taskDialogue.due_date"
                  @input="
                    taskDialogue.due_date_menu = false;
                    taskDialogue.due_date_text = formatDate(
                      taskDialogue.due_date
                    );
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="taskDialogue.user_id_assigned"
                label="Assigned To:"
                :items="taskDialogue.user_list"
                item-text="user_name"
                item-value="user_id"
                clearable
                class="roundish"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 py-4">
          <v-btn
            large
            color="primarylight"
            class="roundish"
            @click="saveTask(true)"
            :disabled="taskDialogue.busy"
            >Set task Cancelled</v-btn
          ><v-spacer></v-spacer>
          <v-btn
            large
            color="primarylight"
            class="roundish"
            @click="saveTask(false)"
            :disabled="taskDialogue.busy"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
// import Pagination from "@/components/cPagination";
// import PageDescription from "@/components/cPageDescription";
// import DocStatus from "@/components/common/DocStatus";
import rmTable from "@/components/common/Table";
import utils from "@/common/utils.js";
import dayjs from "dayjs";
import { mapState } from "vuex";
import DocSummary from "@/components/common/DocViewPopUp";

export default {
  name: "DocumentsWithPartsNew",
  components: {
    ResponseHandler,
    // Pagination,
    // PageDescription,
    // DocStatus,
    rmTable,
    DocSummary,
  },
  props: {},
  data: function () {
    return {
      taskDialogue: {
        show: false,
        busy: false,
        document_task: null,
        user_list: [],
        user_id_assigned: null,
        due_date: null,
        due_date_text: "",
        due_date_menu: false,
        saveAction: "save",
      },
      utils: utils,
      response: null,
      isDirty: false,
      contextMenu: false,
      dialog: false,
      currentTask: {},
      errorText: "",
      showErrorSnack: false,
      snackColor: "error",
      snackTimeout: 4000,
      posX: null,
      posY: null,
      selectedViewIndex: 0,
      notifications: [],
      tasks: [],
      sections: [],
      notificationColumns: [
        {
          column: "notification_type",
          text: "notification",
        },
        {
          column: "activity_by",
          text: "by",
        },
        {
          column: "notification_created_date_formatted",
          text: "Created",
          sort_column: "notification_created_date",
        },
        {
          column: "doc_name",
          text: "job title",
          defaultSort: true,
        },
        {
          column: "comment",
          text: "comment",
          isHTML: true,
        },
        {
          column: "doc_status",
          text: "status",
          isDocStatus: true,
        },
        {
          column: "",
          text: "",
          width: "120px",
          actions: [
            {
              name: "Open Document",
              icon: "mdi-text-box-outline",
              func: "openDocument",
              tooltip: "Open Document",
              dependency: (x) => x.action_available_id,
            },
            {
              name: "Document Summary",
              icon: "mdi-open-in-app",
              func: "openDocumentSummary",
              tooltip: "View Document Summary",
              dependency: (x) => x.action_available_id,
            },
          ],
        },
      ],
      taskColumns: [
        {
          column: "due_date_formatted",
          sort_column: "due_date",
          text: "Due",
          defaultSort: true,
          showCurrent: true,
          showHistorical: true,
        },
        {
          column: "task_type",
          text: "Task",
          showCurrent: true,
          showHistorical: true,
        },
        {
          column: "task_status",
          text: "task status",
          showCurrent: true,
          showHistorical: true,
        },
        {
          column: "closed_date_formatted",
          sort_column: "closed_date",
          text: "Closed",
          showCurrent: false,
          showHistorical: true,
        },
        // {
        //   column: "description",
        //   text: "Description",
        // },
        {
          column: "doc_name",
          text: "Document Title",
          showCurrent: true,
          showHistorical: true,
        },
        {
          column: "doc_status",
          text: "Status",
          isDocStatus: true,
          showCurrent: true,
          showHistorical: true,
        },
        {
          column: "",
          text: "",
          width: "165px",
          showCurrent: true,
          showHistorical: true,
          actions: [
            {
              name: "Open Task",
              icon: "mdi-briefcase-outline",
              func: "openTask",
              tooltip: "View Task",
              dependency: function (x) { return x.task_status !== "Cancelled" },
            },
            {
              name: "Open Document",
              icon: "mdi-text-box-outline",
              func: "openDocument",
              tooltip: "Open Document",
              dependency: function (x) { return !!x.action_available_id && x.task_action === 'OPEN_DOCUMENT' },
            },
            {
              name: "Evaluate Role",
              icon: "mdi-clipboard-list-outline",
              func: "openLevellingEvaluation",
              tooltip: "Evaluate Role",
              dependency: (x) => x.action_available_id && x.task_action === 'LEVELLING_EVALUATION',
            },
            {
              name: "Document Summary",
              icon: "mdi-open-in-app",
              func: "openDocumentSummary",
              tooltip: "View Document Summary",
              dependency: (x) => x.action_available_id,
            },
          ],
        },
      ],
      documentSummary: {
        trigger: null,
        doc_id: null,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    columnSelectionKey() {
      return `${this.$route.name}_twpColumnSelection`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    documentChanged(doc) {
      this.$store.dispatch("docs/updateDoc", doc);
    },
    formatDate(value) {
      return value ? dayjs(value).format("D MMM YYYY") : "";
    },
    parseDate(date) {
      if (!date) return null;
      return dayjs(date).format("YYYY-MM-DD");
    },
    fetchData() {
      
      this.$store.dispatch("tasks/userNotificationsTasks").then((resp) => {
        if (resp.data.Data.length) {
          this.notifications = resp.data.Data[0];
          this.tasks = resp.data.Data[1];
          const pos = this.$refs.tabControl.getBoundingClientRect();
          let heightAvailable = window.innerHeight - pos.top - 200;
          let sections = [
            {
              notifications: this.notifications.filter((x) => !x.seen_date),
              tasks: this.tasks.filter((x) => x.open === '1'),
              message: "",
              textN: "New",
              textT: "Outstanding",
              columnsT: this.taskColumns.filter(x => x.showCurrent),
            },
            {
              notifications: this.notifications.filter((x) => x.seen_date),
              tasks: this.tasks.filter((x) => x.open !== '1'),
              message: "",
              textN: "Previous",
              textT: "Completed/Cancelled",
              columnsT: this.taskColumns.filter(x => x.showHistorical),
            },
          ]
          sections.forEach((s,si) => {
            if (!s.notifications.length) {
              s.message = `You have no ${s.textN.toLowerCase()} notifications`;
            }
            if (!s.tasks.length) {
              s.message += (s.message ? " and" : "You have") + ` no ${s.textT.toLowerCase()} tasks`;
            }
            s.NHeight = s.notifications.length ? s.tasks.length ? heightAvailable / 2 : heightAvailable : 0;
            s.THeight = s.tasks.length ? s.notifications.length ? heightAvailable / 2 : heightAvailable : 0;
          });
          this.sections = sections;

          setTimeout(() => this.$store.dispatch("tasks/setUserNotificationsSeen"), 60000);
        }
      }),
        (error) => {
          console.error(error);
        };
    },
    saveColumnSelection() {
      // this.$loginState.saveSetting(this.columnSelectionKey, this.dtColumnsEnabled);
    },
    openDocument(item) {
      this.contextMenu = false;
      if (item.viewAction) {
        this.$emit("openDocument", item);
      } else if (item.action_available_id) {
        this.$emit("openDocument", {
          doc_id: item.doc_id,
          tmpl_id: item.tmpl_id,
          system_number: utils.removeTags(item.reference),
          doc_name: utils.removeTags(item.doc_name),
          doc_type: item.doc_type,
          viewAction: {
            action_available_id: item.action_available_id,
            action_name: item.action_name,
            document_role_id: item.document_role_id,
            document_role_name: item.document_role_name,
            task: item.document_task_id
              ? {
                  document_task_id: item.document_task_id,
                  task_name: item.task_type,
                  comment: item.comment,
                }
              : null,
          },
        });
      } else {
        this.noPermissionMessage();
      }
    },
    openLevellingEvaluation(item) {
      this.$router.push({ name: 'evaluate', params: { docReference: item.reference } });
    },
    noPermissionMessage() {
      this.response = {
        Status: "Warning",
        Message:
          "You do not currently have permissions to view this document",
        Timeout: 3000,
      };
    },
    openContextMenu(e, item) {
      this.currentTask = item;
      e.preventDefault();
      this.contextMenu = false;
      this.posX = e.clientX;
      this.posY = e.clientY;
      this.$nextTick(() => {
        this.contextMenu = true;
      });
    },
    openTask(task) {
      let possibleError = false;
      if (task.task_status === "Cancelled") {
        alert("Can't edit a Cancelled task");
        return;
      }
      this.currentTask = task;

      axios
        .get("workflow/task/" + task.document_task_id)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.taskDialogue.document_task = resp.data.Data.document_task;
            this.taskDialogue.user_list = resp.data.Data.user_list;
            this.taskDialogue.user_id_assigned =
              resp.data.Data.document_task.user_id_assigned;
            this.taskDialogue.due_date = resp.data.Data.document_task.due_date;
            this.taskDialogue.due_date_text =
              resp.data.Data.document_task.due_date_text;
            this.taskDialogue.show = true;
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    saveTask(cancelTask) {
      let possibleError = false;
      let userName = "";

      let data = { ...this.taskDialogue.document_task };
      data.reassigned = 0;
      data.isCancelled = !!cancelTask;
      data.isDirty = false;
      if (
        this.taskDialogue.document_task.user_id_assigned !==
        this.taskDialogue.user_id_assigned
      ) {
        data.user_id_assigned = this.taskDialogue.user_id_assigned;
        userName = data.user_id_assigned
          ? this.taskDialogue.user_list.find(
              (x) => x.user_id === data.user_id_assigned
            ).user_name
          : "UNASSIGNED";
        data.reassigned = 1;
        data.isDirty = true;
      }
      if (
        this.taskDialogue.document_task.due_date !== this.taskDialogue.due_date
      ) {
        data.due_date = this.taskDialogue.due_date;
        data.due_date_text = this.formatDate(this.taskDialogue.due_date);
        data.isDirty = true;
      }
      if (!data.isDirty && !cancelTask) {
        this.taskDialogue.show = false;
        return;
      }
      this.taskDialogue.busy = true;

      axios
        .post("workflow/updateTask/", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (cancelTask) {
              this.currentTask.task_status = "Cancelled";
              this.currentTask.task_status_colour = "yellow";
              this.currentTask.user_name_assigned = "";
            } else {
              this.currentTask.due_date = data.due_date;
              if (data.reassigned) {
                this.currentTask.user_name_assigned = userName;
                this.currentTask.task_status = "Open";
                this.currentTask.task_status_colour = "amber";
              }
            }
            this.taskDialogue.show = false;
          }
          this.taskDialogue.busy = false;
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.taskDialogue.busy = false;
        });
    },
    triggerNotification(text, type) {
      this.errorText = text;
      this.snackColor = type;
      this.showErrorSnack = true;
    },
    handleRowAction(action, row, event) {
      this[action.func](row, event);
    },
    openDocumentSummary(item, event) {
      if (item.action_available_id) {
        this.documentSummary.doc_id = item.doc_id;
        this.documentSummary.trigger = event;
      } else {
        this.noPermissionMessage();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";

.flex-container {
  display: flex;

  .left-col {
    z-index: 3;
    flex: 0 0 400px;
    width: 400px !important;
    height: calc(100vh - 48px) !important;
    position: fixed;
    top: 48px !important;
    left: var(--side-menu-width, 0px);
    overflow: visible !important;
    &.collapsed {
      left: 20px;
    }
  }

  @media (max-width: 600px) {
    .right-col {
      padding-left: 0;
    }
  }
}

.filter-col {
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 50%;
  @media (min-width: 960px) {
    max-width: 25%;
  }
  @media (min-width: 1264px) {
    max-width: 14%;
  }
}

.header-buttons {
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  max-width: 100%;
}

.btn-background {
  height: 44px;
  ::v-deep .v-input__slot {
    background: transparent !important;
  }
}

.headerCount {
  display: flex;
  align-items: center;
  padding: 0 60px 0 0;
  margin: -45px 0 15px 0;
  span {
    margin: 0 20px;
  }
}

.mainPane > .v-card {
  border-radius: 10px;
}

::v-deep mark {
  color: inherit;
  border-radius: 5px;
  background-color: rgba(#0372ee, 0.3);
}

::v-deep .v-select__selections {
  overflow: hidden;
  white-space: nowrap;
  flex-flow: nowrap;
}

.fixedFooter {
  @media (max-width: 600px) {
    .docList .footer-actions {
      padding-left: 15px;
    }
  }

  .left-col {
    height: calc(100vh - 103px) !important;
  }
  .mainPane {
    padding-bottom: 56px;
  }

  .docList {
    .footer-actions {
      width: calc(100% - var(--side-menu-width, 0px));
      position: fixed;
      bottom: 0;
      left: var(--side-menu-width, 0px);
      right: 0;
      z-index: 4;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
}

.multipane {
  .multipane-resizer {
    margin: 0;
    left: 0;
    position: relative;
    height: 20px;
    &:before {
      display: block;
      content: "";
      width: 40%;

      position: absolute;
      left: 30%;
      margin-top: 5px;
      margin-left: -20px;
      border: 2px solid #ccc;
      border-radius: 2px;
    }
    &:hover {
      &:before {
        border-color: #999;
      }
    }
  }

  .mainPane {
    padding-top: 12px;
    padding-right: 12px;
    min-height: 100px;
    max-height: 100%;
    &.fixedHeader {
      padding-right: 0;
      overflow: hidden;
    }
  }
  .previewPane {
    width: 100%;
    height: 100px;
    display: flex;
    flex-grow: 1;
    position: relative;
    .actions {
      position: absolute;
      top: 0;
      right: 25px;
      width: 44px;
      button {
        z-index: 1;
        opacity: 0.8;
      }
    }

    .docPreview {
      width: 100%;
      min-height: 100%;
      height: 100%;
      overflow-y: auto;
      padding: 12px 85px 0 85px;
      //height: calc(50vh - 35px);
      //overflow-y: auto;
    }
  }
  &.hasPreview {
    height: calc(100vh - 105px);
    .mainPane {
      height: 100%;
      overflow-x: hidden;
      padding-bottom: 12px;
    }
  }
  // &:not(.hasPreview) {
  //   .mainPane {
  //     height: 100%;
  //     overflow: unset;
  //   }
  // }
}

.v-application.theme--light {
  .previewPane {
    ::v-deep .docPreview {
      background-color: $background-color-light;
      > .v-card {
        box-shadow: 0 0 4px 0 #b5b5b5;
      }
    }
  }
}

.v-application.theme--dark {
  .previewPane {
    ::v-deep .docPreview {
      > .v-card {
        border: 1px solid #b5b5b5;
      }
    }
  }
}

.docList {
  .footer-actions {
    display: flex;
    align-items: center;
    padding: 0 15px;
    height: 55px;

    div {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
    }
  }

  .v-card.doc-card {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  .v-card.on-hover.theme--light .v-list {
    background-color: #f7f7f7;
  }

  .v-card.on-hover.theme--dark .v-list {
    background-color: #272727;
  }

  .data-content {
    margin-top: -5px;
    padding-top: 0;
  }
  .data-content-2 {
    margin-top: -7px;
    min-height: auto !important;
    max-height: auto;
    padding-bottom: 0;
  }
  .data-label {
    font-size: 0.6rem;
    padding: 0 5px 0 16px;
    color: darkgray;
  }
  .data-value {
    font-size: 0.9rem;
  }
  .data-value-2 {
    font-size: 0.75rem;

    padding-bottom: 10px;
  }

  .doc-card .status-chip {
    background-color: transparent !important;
    :before {
      content: "\2022";
      margin-right: 0.5em;
    }
  }

  ::v-deep .v-data-table {
    tbody > tr,
    tbody > tr span {
      cursor: pointer;
    }
    tr td:last-child {
      padding: 0 10px 0 0;
    }
    .status-chip {
      height: 2.35em;
      min-width: 7.2em;
      display: inline-flex;
      justify-content: center;
      font-size: 0.5625rem;
    }
  }
}
</style>
